import React from "react";
import { Box, ToggleButtonGroup, ToggleButton, Typography, IconButton } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SellIcon from "@mui/icons-material/Sell";
import CloseIcon from "@mui/icons-material/Close";

const OrderWindowHeader = ({
  isMobile,
  orderSide,
  onTypeChange,
  isModify,
  type,
  displayName,
  onClose,
  marketStatus,
}) => {
  const theme = useTheme();
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ToggleButtonGroup
          value={orderSide}
          exclusive
          onChange={onTypeChange}
          size={isMobile ? "small" : "medium"}
          sx={{
            backgroundColor:
              orderSide === "BUY"
                ? theme.palette.buy.background
                : theme.palette.sell.background,
            padding: "2px",
            borderRadius: "12px",
            boxShadow: theme.shadows[2],
          }}
        >
          <ToggleButton
            value="BUY"
            disabled={isModify && type === "SELL"}
            sx={{
              color: theme.palette.text.primary,
              borderColor: "transparent",
              backgroundColor:
                orderSide === "BUY"
                  ? theme.palette.buy.background
                  : "transparent",
              "&.Mui-selected": {
                backgroundColor: theme.palette.buy.background,
                color: theme.palette.primary.contrastText,
                fontWeight: "bold",
                boxShadow: theme.shadows[4],
              },
              "&:hover": {
                backgroundColor: theme.palette.buy.background,
                opacity: 0.9,
              },
              minWidth: isMobile ? "60px" : "70px",
              px: isMobile ? 1 : 2,
              borderRadius: "10px",
              transition: "all 0.3s ease",
              "&.Mui-disabled": {
                opacity: 0.5,
                color: alpha(theme.palette.primary.contrastText, 0.5),
              },
            }}
          >
            <ShoppingCartIcon
              sx={{
                mr: 0.5,
                fontSize: isMobile ? "1.2rem" : "1.4rem",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" },
              }}
            />
            BUY
          </ToggleButton>
          <ToggleButton
            value="SELL"
            disabled={isModify && type === "BUY"}
            sx={{
              color: theme.palette.text.primary,
              borderColor: "transparent",
              backgroundColor:
                orderSide === "SELL"
                  ? theme.palette.sell.background
                  : "transparent",
              "&.Mui-selected": {
                backgroundColor: theme.palette.sell.background,
                color: theme.palette.primary.contrastText,
                fontWeight: "bold",
                boxShadow: theme.shadows[4],
              },
              "&:hover": {
                backgroundColor: theme.palette.sell.background,
                opacity: 0.9,
              },
              minWidth: isMobile ? "60px" : "70px",
              px: isMobile ? 1 : 2,
              borderRadius: "10px",
              transition: "all 0.3s ease",
              "&.Mui-disabled": {
                opacity: 0.5,
                color: alpha(theme.palette.primary.contrastText, 0.5),
              },
            }}
          >
            <SellIcon
              sx={{
                mr: 0.5,
                fontSize: isMobile ? "1.2rem" : "1.4rem",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" },
              }}
            />
            SELL
          </ToggleButton>
        </ToggleButtonGroup>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant={isMobile ? "body1" : "subtitle1"}
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
              ml: 1,
              textShadow: "0 1px 3px rgba(0,0,0,0.2)",
            }}
          >
            {displayName}
            {/* Mobile: status flows right after the name's last word and wraps like text */}
            {isMobile && marketStatus && <>{" "}{marketStatus}</>}
          </Typography>
        </Box>
      </Box>
      {/* Desktop: auto margin pushes the status right, against the close icon */}
      {!isMobile && marketStatus && <Box sx={{ display: 'flex', ml: 'auto', pl: 1, mr: 0.5 }}>{marketStatus}</Box>}
      <IconButton
        size={isMobile ? "small" : "medium"}
        onClick={onClose}
        sx={{
          color: theme.palette.text.primary,
          transition: "transform 0.2s ease",
          "&:hover": {
            transform: "rotate(90deg)",
            backgroundColor: alpha(theme.palette.text.primary, 0.2),
          },
        }}
      >
        <CloseIcon />
      </IconButton>
    </>
  );
};

export default OrderWindowHeader;


